export default "__VITE_ASSET__b6be3486__"